<template>
	<v-skeleton-loader v-if="loading" type="article,list-item,list-item,list-item"></v-skeleton-loader>
	<v-card v-else-if="!loading" class="mx-auto my-8 pa-6 full-width" max-width="794"
			color="#F2F2F2" fill-height>
		<template>
			<v-card-title class="ma-0 pa-0">
				<div class="d-flex justify-space-between align-center full-width ma-0 pa-0">
					<div>
						<h3 class="text-left  font-weight-regular" :class="{ 'subtitle-2': isMobile }">
							{{ $t('reservation.detail', { resId: reservation.data.reservation_id }) }}
						</h3>
						<p v-if="Paid || Cancelled" class="caption text-left  font-weight-regular ma-0">{{
								$t('reservation.date', { date: reservation.data.created_at })
							}} <span class="font-weight-bold" v-if="Paid">{{ $t('reservation.fully_paid') }}</span></p>
					</div>
					<div class="px-2 py-1 res-status-container text-right">
						<p class="pa-0 ma-0 caption font-weight-regular  black--text">{{
								$t('reservation.status')
							}}</p>
						<p class="pa-0 ma-0 headline  font-weight-bold"
						   :class="[{ 'subtitle-2': isMobile }, statusData[reservation.data.status].color]"
						   v-text="statusData[reservation.data.status].text"></p>
					</div>
				</div>
			</v-card-title>
			<v-card-text class="mt-6 pa-0">
				<div class="d-flex justify-space-between align-sm-center full-width ma-0 pa-0  flex-sm-row flex-column"
					 :class="{ '': isMobile }">
					<div class="white pa-3 mb-6 mb-sm-0 res-date-container" :class="{ 'full-width': isMobile }">
						<p class="pa-0 ma-0 grey--text text--darken-4 caption ">
							<span v-for="resInfo in reservationInfo" v-if="resInfo.condition">{{
									resInfo.text
								}}<br></span>
							<span v-if="reservation.data.quote_number">
								{{ $t('reservation.quote_number') }} :
								{{ reservation.data.quote_number }}
							</span>
						</p>
					</div>
					<div class="pa-3 res-date-container text-left white"
						 :class="{ 'full-width height_auto': isMobile }">
						<div class="pa-0 ma-0 caption grey--text text--darken-4 ">
							<p class="pa-0 ma-0" v-if="account.data.id">
								{{ $t('reservation.client_id', { id: account.data.id }) }}</p>
							<p class="pa-0 ma-0" v-if="account.data.company_name">
								{{ $t('reservation.company_name', { name: account.data.company_name }) }}</p>
							<p class="pa-0 ma-0" v-if="account.data.firstname">{{ account.data.firstname }}
								{{ account.data.lastname }}</p>
							<p class="pa-0 ma-0"
							   v-if="account.data.address_info && account.data.address_info.length > 0">
								{{ account.data.address_info.address1 }}</p>
							<p class="pa-0 ma-0"
							   v-if="account.data.address_info && account.data.address_info.length > 0">
								{{ account.data.address_info.city }} , {{
									account.data.address_info.zipcode_postalcode
								}}</p>
						</div>
					</div>
				</div>

				<div class="d-flex justify-space-between full-width my-6 pa-6 white"
					 :class="{ 'flex-column': CancelledResponsive1, 'align-center': CancelledResponsive2 }">
					<div :class="{ 'full-width': CancelledResponsive1 }">
						<p v-if="Cancelled || Quote || Confirmed"
						   class="pa-0 ma-0 black--text font-weight-bold subtitle-1 "
						   v-text="$t(statusData[reservation.data.status].reservationMessage)">
						</p>

						<p v-if="!Cancelled && !Quote" class="pa-0 ma-0 black--text caption "
						   v-text="statusData[reservation.data.status].balanceStatusText"></p>
						<p v-if="Quote" class="pa-0 ma-0 grey--text font-weight-bold caption ">
							{{ $t('reservation.non_refundable') }} <a v-if="false" href="#" class="black--text">{{
								$t('reservation.more_info')
							}}</a>
						</p>
					</div>
					<v-card-actions class="pa-0"
									:class="{ 'full-width d-flex justify-end mt-3': CancelledResponsive1, 'align-end flex-column': windowWidth < 480 }">
						<v-btn v-if="Paid" color="light-blue" class="px-3 py-5 ma-0 ml-3 font-weight-bold caption"
							   outlined @click="onDownloadPdfClick()" :disabled="isPDFBtnDisabled">
							<v-icon class="pr-1">mdi-file-pdf</v-icon>
							{{ $t('btn.product_codes') }}
						</v-btn>
						<v-btn color="green" class="px-3 py-5 ma-0 mr-3 font-weight-bold caption"
							   :class="{ 'ml-3': Paid, 'mb-4': windowWidth < 480 }"
							   outlined @click="onViewPdfClick()">
							<v-icon class="pr-1">mdi-file-pdf</v-icon>
							{{ $t('btn.pdf') }}
						</v-btn>
						<v-btn v-if="(Quote || Confirmed) && reservation.data.balance > 0 && enableSelfPayment"
							   :class="{ 'mb-4': windowWidth < 480 }" @click="handleSelfPay()"
							   class="px-3 py-5 ma-0 green lighten-1 white--text font-weight-bold caption">
							<v-icon class="pr-1">{{ Confirmed && 'mdi-basket' || 'mdi-check-circle' }}</v-icon>
							{{ $t('btn.pay_reservation') }}
						</v-btn>
					</v-card-actions>
				</div>

				<SummaryOrderCard :cart.sync="reservation" :payments.sync="payments" :skeleton="skeleton"
								  :showDepositSection="true" class="pa-0 py-sm-12 pa-6 pa-print-0 mb-8 full-width"/>
				<SelfPayDialog
					:visible.sync="selfPayDialog.visible"
					:max-width="450"
					:cart="reservation"
					:payments.sync="payments"
					@completed="completedPay"
				/>

				<div v-if="Notes" class="full-width my-6 px-6 pt-6 pb-9 white">
					<p class="black--text headline " :class="{ 'subtitle-1': isMobile }"
					   v-text="$t('reservation.note_title')"></p>
					<div class="pa-2 mx-3" style="border: 1px solid #E0E0E0">
						<p class="black--text ma-0 pa-0 subtitle-1 " :class="{ 'caption': isMobile }"
						   v-text="Notes">
						</p>
					</div>
				</div>
			</v-card-text>
		</template>
	</v-card>
</template>

<script>
import SummaryOrderCard from '@/components/SummaryOrderCard'
import { WindowWidthMixin } from '@/mixins/ProductMixin'
import { AccountModel, BaseModel, EComService, EventBus, PaymentModel, TransactionModel } from '@connectngo/sdk'
import SelfPayDialog from '@/routes/App/Reservation/SelfPayDialog'
export default {
	name: 'Reservation',
	mixins: [WindowWidthMixin],
	components: { SummaryOrderCard, SelfPayDialog },

	data: () => ({
		loading: false,
		skeleton: true,
		reservation: new TransactionModel(),
		payments: new PaymentModel(),
		account: new AccountModel(),
		transactionPdf: new BaseModel(),
		productsPdf: new BaseModel(),
		pdfType: 'RESERVATION',
		pdfCustomerType: 'INDIVIDUAL',
		showLoginModal: false,
		enableSelfPayment: false,
		reservationInfo: Array,
		eventSubscriber: null,
		selfPayDialog: {
			visible: false,
		},
		hasFailedTriedToComplete: false,
	}),

	mounted () {
		this.eventSubscriber = EventBus.subscribe('REZA_UPDATED', () => {
			this.load()
		})
	},
	destroyed () {
		this.eventSubscriber.unsubscribe()
	},

	watch: {
		'$root.user.data.id': {
			handler (value) {
				if (!value) {
					this.redirectToLogin('login')
				}
			}
		},
	},

	methods: {
		handleSelfPay () {
			Object.assign(this.selfPayDialog, {
				visible: true,
			})
		},

		shouldAutoComplete (paymentResponseArgs = null) {
			return !this.$root.websiteConfig.data.tenant.fields_data.reservation_manual_convert
				&&
				(
					(
						this.reservation.data.became_invoice_at === null
						&& this.reservation.data.can_be_completed === true
					)
					|| paymentResponseArgs?.paid === true
				)
		},

		completedPay(args) {
			if (this.hasFailedTriedToComplete) return;

			if (this.shouldAutoComplete(args)) {
				this.loading = true
				Promise.all([
					new EComService().completeReservation(this.reservation.data.uuid),
				]).then(() => {
					Object.assign(this.selfPayDialog, {
						visible: false,
					})
					this.load(true)
				}).catch(reason => {
					this.hasFailedTriedToComplete = true;
					this.$handleError(this, reason)
				}).finally(() => {
					this.loading = false
				})
			} else {
				Object.assign(this.selfPayDialog, {
					visible: false,
				})
				this.load(true)
			}
		},

		triggerSelfPayDialog () {
			Object.assign(this.selfPayDialog, {
				visible: true
			})
		},

		load (resetRouteAfter3ds = false) {
			if (resetRouteAfter3ds && this.$route.name !== 'reservation') {
				this.$router.push({
					name: 'reservation',
					params: this.$route.params
				})
			}
			this.loading = true
			this.enableSelfPayment = this.$root.websiteConfig.data.tenant.fields_data.disable_full_deposit_payment == '0' ? true : false
			this.reservationDepositPercentage = this.$root.websiteConfig.data.tenant.fields_data.reservation_deposit_percentage

			return Promise.all([
				new EComService().getReservationDetails(this.$route.params.resId),
			])
				.then(([reservation]) => {
					this.reservation = reservation
					Object.assign(this, {
						reservation,
						payments: new PaymentModel({
							balance: parseFloat(reservation.data.balance).toFixed(2),
							payments: reservation.data.allPayments,
						}),
						account: new AccountModel(reservation.data.account)
					})

					this.reservation.deposit = false

					if (this.reservationDepositPercentage != '0') {
						this.reservation.deposit = true
						this.reservation.depositAmount = this.reservation.applyDepositPercentage(this.reservationDepositPercentage)
					}

					this.skeleton = false
					this.assignData()

					if (this.shouldAutoComplete()) {
						this.completedPay(null)
					}
				})
				.catch(reason => this.$handleError(this, reason))
				.finally(() => {
					this.loading = false
					// Use new async PDF generation flow if feature flag is enabled
					if (this.asyncPdfGenerationEnabled) {
						this.fetchReservationPdfs()
					} else {
						this.handleInvoice()
					}
				})
		},

		handleInvoice () {
			if (!this.reservation?.data?.need_fulfillment) {
				this.apiForInvoice()
				return
			}

			const uuid = this.reservation?.data?.uuid
			if (!uuid) {
				console.warn('Missing reservation uuid for fulfillment.')
				this.apiForInvoice()
				return
			}

			new EComService().autoFulfillInvoice(uuid)
				.catch((err) => {
					console.error('Auto-fulfillment failed:', err)
				})
				.finally(() => {
					this.apiForInvoice()
				})
		},

		formatDate (date) {
			return this.$options.filters.tsToFormat(date, this.$t('date.format.ymd'))
		},

		onViewPdfClick () {
			if (!this.transactionPdf) {
				this.$handleError(this, { message: this.$t('alert.genericError') })
				return
			}
			window.open(this.transactionPdf.data.url)
		},

		onDownloadPdfClick () {
			if (!this.productsPdf) return
			const byteCharacters = atob(this.productsPdf.data.base_64)
			const byteNumbers = new Array(byteCharacters.length)
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i)
			}
			const byteArray = new Uint8Array(byteNumbers)
			const file = new Blob([byteArray], { type: 'application/pdf;base64' })
			const fileURL = URL.createObjectURL(file)
			window.open(fileURL)
		},

		async fetchReservationPdfs () {
			try {
				// Wait for PDF generation to complete (if feature flag is enabled)
				if (this.asyncPdfGenerationEnabled) {
					await this.waitForPdfGeneration()
				}

				const [productsPdf, transactionPdf] = await Promise.all([
					new EComService().getProductsPdf(this.$route.params.resId),
					new EComService().getTransactionPdf(this.$route.params.resId, this.pdfType, this.pdfCustomerType),
				])

				this.productsPdf = productsPdf
				this.transactionPdf = transactionPdf
			} catch (reason) {
				this.$handleError(this, reason)
			} finally {
				this.loading = false
			}
		},

		async waitForPdfGeneration (maxAttempts = 10, delayMs = 1000) {
			// Check if transaction fulfillment is ready once at the start
			if (this.reservation?.data?.fulfillment_ready === false) {
				// Need to poll for PDF generation completion
				for (let attempt = 0; attempt < maxAttempts; attempt++) {
					try {
						// Check both fulfillment status and PDF status
						const [reservation, status] = await Promise.all([
							new EComService().getReservationDetails(this.$route.params.resId),
							new EComService().getProductsPdfStatus(this.$route.params.resId)
						])

						// Update reservation data with latest info
						if (reservation?.data) {
							this.reservation.data.fulfillment_ready = reservation.data.fulfillment_ready
						}

						// If PDF is ready (has URL), generation is complete
						if (status?.data?.url) {
							return
						}

						// If fulfillment is now ready, we can stop polling
						if (reservation?.data?.fulfillment_ready === true) {
							return
						}

						// Wait before next attempt (except on last attempt)
						if (attempt < maxAttempts - 1) {
							await new Promise(resolve => setTimeout(resolve, delayMs))
						}
					} catch (_error) { // NOSONAR - Gracefully degrade on status check failure
						throw new Error(this.$t('alert.tryAgainLater'))
					}
				}

				// If we get here, polling timed out without PDF being ready
				throw new Error(this.$t('alert.tryAgainLater'))
			}
		},

		apiForInvoice () {
			return Promise.all([
				new EComService().getProductsPdf(this.$route.params.resId),
				new EComService().getTransactionPdf(this.$route.params.resId, this.pdfType, this.pdfCustomerType),
			])
				.then(([productsPdf, transactionPdf]) => {
					Object.assign(this, { productsPdf })
					Object.assign(this, { transactionPdf })
				})
				.catch(reason => this.$handleError(this, reason))
				.finally(() => (this.loading = false))
		},

		redirectToLogin (page) {
			if (page === 'login') {
				this.$router.push({ name: 'res-login', params: { resId: this.$route.params.resId } })
			} else {
				this.$router.push({ name: 'home' })
			}
		},

		handleLogoutClick () {
			EventBus.publish('RES_LOGOUT')
		},

		onResize () {
			this.isMobile = window.innerWidth < 600
			this.windowWidth = window.innerWidth
		},

		assignData () {
			this.reservationInfo = [
				{
					condition: this.Quote || this.Confirmed,
					text: this.$t('reservation.date', { date: this.formatDate(this.reservation.data.created_at) })
				},
				{
					condition: this.Paid || this.Cancelled,
					text: this.$t('reservation.invoice', { resId: this.reservation.data.reservation_id })
				},
				{
					condition: this.Paid,
					text: this.$t('reservation.paid_on', { date: this.formatDate(this.reservation.data.became_invoice_at) })
				},
				{
					condition: true,
					text: this.$t('reservation.visiting_date', { date: this.formatDate(this.reservation.data.reservation_date) })
				},
				{
					condition: this.Cancelled,
					text: this.$t('reservation.cancellation_date', { date: this.formatDate(this.reservation.data.deleted_at) })
				},
			]
		}
	},

	computed: {
		asyncPdfGenerationEnabled() {
			const { feature_flags } = this.$root?.websiteConfig?.data || {};
			return !!(feature_flags && feature_flags.includes('co-10736-async-pdf-generation'))
		},
		Quote () {
			return this.reservation.data.status === 'QUOTE'
		},
		Confirmed () {
			return this.reservation.data.status === 'CONFIRMED'
		},
		Paid () {
			return this.reservation.data.status === 'PAID'
		},
		Cancelled () {
			return this.reservation.data.status === 'CANCELLED'
		},

		CancelledResponsive1 () {
			return !this.Cancelled && this.windowWidth < 790 || this.windowWidth < 480
		},

		CancelledResponsive2 () {
			return this.windowWidth > 789 || this.Cancelled && this.windowWidth > 480
		},

		Notes () {
			return this.reservation.data.fields.note != '' && this.reservation.data.fields.note
		},
		statusData () {
			return {
				QUOTE: {
					text: this.$t('reservation.quote'),
					balanceStatusText: this.$t('reservation.confirm_quote', { date: '11/14/2022' }),
					color: 'purple--text',
					reservationMessage: 'reservation.not_reserved',
				},
				CONFIRMED: {
					text: this.$t('reservation.confirmed'),
					balanceStatusText: this.$t('reservation.pay_balance'),
					color: 'warning--text',
					reservationMessage: 'reservation.reservation_confirmed',
				},
				PAID: {
					text: this.$t('reservation.paid'),
					balanceStatusText: this.$t('reservation.paid_and_reserved'),
					color: 'success--text',
					reservationMessage: '',
				},
				CANCELLED: {
					text: this.$t('reservation.cancelled'),
					color: 'error--text',
					reservationMessage: 'reservation.reservation_cancelled',
				},
			}
		},
		isPDFBtnDisabled () {
			return this.productsPdf?.data?.base_64 == null
		}
	},

	created () {
		this.loading = false
		this.load()
		// Use new async PDF generation flow if feature flag is enabled
		if (this.asyncPdfGenerationEnabled) {
			this.fetchReservationPdfs()
		} else {
			this.apiForInvoice()
		}
		if (this.$route.name === 'reservation_3ds') {
			this.triggerSelfPayDialog()
		}
	},
}
</script>

<style lang="scss" scoped>
.res-status-container {
	background-color: #fff;
}

.res-date-container {
	height: 114px;
	width: calc(50% - 12px);
}
</style>
